import React from "react";
import { useSelector } from "react-redux";
import cx from "classnames"
import Wrapper from "./sectionHeading.styles";
import { useSetTitle } from "../../containers/PersonalLoan/context/formContext/header";

export default ({heading, subheading, asMobileHeader, hideMobile, className, soft}) => {
  const asMobileHeaderBool = !!asMobileHeader;
  useSetTitle(heading ?? subheading, asMobileHeaderBool);
  
  const { theme } = useSelector((state) => state.StartUp);
  const blackHeading = theme === "rentBondTheme";
  
  return (
    <Wrapper $asMobileHeader={asMobileHeaderBool} $hideMobile={hideMobile} className={cx(className, {uppercase: !soft})}>
      {heading && <h1 className={cx("page-heading", {isBlackHeading: blackHeading})}>{heading}</h1>}
      {subheading && (
        <p className="page-subheading">{subheading}</p>
      )}
    </Wrapper>
  );
}
